import { useTheme } from '@approvalmax/theme';
import { SpacingProp } from '@approvalmax/types';
import { useMedia } from 'react-use';

/** Hook for preparing values for adaptation on different screens */
export const useAdaptation = () => {
    const { theme } = useTheme();
    const xsmallViewport = useMedia(`(max-width: ${theme.container.breakpoint.xsmall})`);

    const ssoPanelSpacing: SpacingProp['spacing'] = xsmallViewport
        ? `16 ${parseInt(theme.container.spacing.xsmall)} 0`
        : '16 0 0';

    return { ssoPanelSpacing };
};
